import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { postalsOptions } from '../data-provider';
import type { PostalsParams } from '../models';

export const usePostals = (params: PostalsParams) => useQuery(postalsOptions(params));
export const useSuspensePostals = (params: PostalsParams) => useSuspenseQuery(postalsOptions(params));
